import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output } from '@angular/core';

import { viewService } from '@unpispas/upp-base';

@Component({
    selector: 'upp-overlay',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-overlay.html',
    styleUrls: ['./upp-overlay.scss'],
})
export class UppOverlayComponent {
    @Output() OnClose = new EventEmitter<void>();

    constructor(public view: viewService) {}

    @HostBinding('class.mobile')
    get IsMobile(): boolean {
        return this.view.Mobile === true;
    }

    @HostBinding('class.desktop')
    get IsDesktop(): boolean {
        return this.view.Desktop === true;
    }

    OnOverlayClick(): void {
        this.OnClose.emit();
    }

    OnOverlayKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' '){
            event.preventDefault();
            this.OnClose.emit();
        }
    }

    OnPanelClick(event: Event): void {
        event.stopPropagation();
    }

    OnPanelKeydown(event: Event): void {
        event.stopPropagation();
    }
}
